import React, { useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";

import RNDatePicker, {
  getFormatedDate,
  ModernDatepickerProps,
} from "react-native-modern-datepicker";
import Button from "components/Button";
import Icon from "components/Icon";
import Text from "components/Text";

import { colors, sizes, strings } from "assets/constants";
import { useRecoilValue } from "recoil";
import fonts from "assets/fonts";
import { authAtom } from "stores";
import { useFlag } from "hooks";
import { mq } from "utils";
import { styles } from "./styles";
import Modal from "components/Modal";

export default function DatePicker(props: DatePickerT & ModernDatepickerProps) {
  const {
    company: { color },
  } = useRecoilValue(authAtom);
  const { flg: modal, on: showModal, off: hideModal } = useFlag();
  const { flg: buttons, on: showButtons, off: hideButtons } = useFlag(true);

  const { value, placeholder, onSelect, hideError, error, disabled } = props;

  const [valueState, setValueState] = useState(value);

  const [selected, setSelected] = useState("");

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return (
    <>
      <>
        <TouchableOpacity
          disabled={disabled}
          onPress={showModal}
          activeOpacity={sizes.tapOpacity}
          style={styles.inputContainer}
        >
          <View style={styles.iconContainer}>
            <Icon name="chevron-down" />
          </View>
          <View style={styles.textContainer}>
            <Text
              weight={valueState ? "bold" : "default"}
              color={valueState ? colors.textColorDefault : colors.placeholder}
            >
              {valueState
                ? typeof valueState === "string"
                  ? valueState
                  : getFormatedDate(valueState, "jYYYY/jM/jDD")
                : placeholder}
            </Text>
          </View>

          <View style={styles.iconContainer}>
            <Icon name="calendar" />
          </View>
        </TouchableOpacity>
        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <Modal visible={modal} close={hideModal}>
        <View style={styles.calendarContainer}>
          <RNDatePicker
            onMonthYearChange={showButtons}
            _onMonthYearInHeaderTap={hideButtons}
            current={valueState ?? getFormatedDate(new Date(), "jYYYY/jM/jDD")}
            selected={valueState ?? getFormatedDate(new Date(), "jYYYY/jM/jDD")}
            mode="calendar"
            onSelectedChange={setSelected}
            options={{
              mainColor: color,
              textFontSize: 18,
              headerFont: fonts.fa.bold,
              textHeaderFontSize: 18,
              daysAnimationDistance: 0,
              defaultFont: fonts.fa.medium,
            }}
            style={{
              borderRadius: sizes.radius.md,
              width: "100%",
              height: "100%",
            }}
            isGregorian={false}
            {...props}
          />
        </View>
        <View style={styles.modalBtnContainer}>
          {buttons && (
            <>
              <Button
                onPress={() => {
                  setValueState(selected);
                  onSelect && onSelect(selected);
                  hideModal();
                }}
                width={mq(120)}
                height={mq(45)}
                bgColor={colors.success}
                title={{ value: strings.confirm, size: "xl" }}
                bordered={{ width: 1, color: colors.success }}
              />
              <Button
                width={mq(100)}
                height={mq(45)}
                bgColor={colors.danger}
                title={{ value: strings.cancel, size: "xl" }}
                style={{ marginLeft: sizes.space }}
                outline
                onPress={hideModal}
              />
            </>
          )}
        </View>
      </Modal>
    </>
  );
}
